const API_URL = process.env.REACT_APP_API_URL;

export const syncMealPlanToCalendar = async (token: string, planId: string): Promise<void> => {
  const response = await fetch(`${API_URL}/api/calendar/sync/${planId}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to sync meal plan to calendar');
  }
};

export const removeMealPlanFromCalendar = async (token: string, planId: string): Promise<void> => {
  const response = await fetch(`${API_URL}/api/calendar/sync/${planId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to remove calendar events');
  }
};
